import { ChangeEvent, useCallback, useEffect, useState } from 'react';
import { setDebouncedValue, setDefaultDebouncedValue, setIsEnabledSearch } from 'app/store/reducers/search.reducer';
import { useAppDispatch, useAppSelector } from 'app/store/store.hooks';

export const useSearchPanel = () => {
  const [value, setValue] = useState<string>('');
  const [debounceValue, setDebounceValue] = useState<string>('');

  const dispatch = useAppDispatch();
  const { isEnabledSearch, debouncedValue } = useAppSelector((state) => state.search);

  useEffect(() => {
    const timeout = setTimeout(() => setDebounceValue(value), 300);

    return () => clearTimeout(timeout);
  }, [value]);

  useEffect(() => {
    if (debounceValue !== debouncedValue) {
      dispatch(setDebouncedValue(debounceValue));
    }
  }, [debounceValue]);

  const handleOnChange = useCallback((event: ChangeEvent<HTMLInputElement>) => setValue(event.target.value), []);

  const handleSetIsEnabled = useCallback(
    (value: boolean) => {
      if (isEnabledSearch !== value) {
        dispatch(setIsEnabledSearch(value));
      }
    },
    [isEnabledSearch]
  );

  const handleCancelSearch = useCallback(() => {
    dispatch(setIsEnabledSearch(false));
    dispatch(setDefaultDebouncedValue());

    setValue('');
  }, []);

  return { value, isEnabledSearch, handleOnChange, handleSetIsEnabled, handleCancelSearch };
};
